import { render, staticRenderFns } from "./HRecommend.vue?vue&type=template&id=3df47dba&scoped=true&"
import script from "./HRecommend.vue?vue&type=script&lang=js&"
export * from "./HRecommend.vue?vue&type=script&lang=js&"
import style0 from "./HRecommend.vue?vue&type=style&index=0&id=3df47dba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df47dba",
  null
  
)

export default component.exports